import { render, staticRenderFns } from "./ResourceDown.vue?vue&type=template&id=5853c0fc&scoped=true&"
import script from "./ResourceDown.vue?vue&type=script&lang=js&"
export * from "./ResourceDown.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDown.vue?vue&type=style&index=0&id=5853c0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5853c0fc",
  null
  
)

export default component.exports